import { ROUTES } from '../constants/routesPaths'

export const INVITE_HASH_PARAM_NAME = 'fchash'
export const SIGNUP_APPROVAL_HASH_PARAM_NAME = 'hash'

export enum SEARCH_PARAMS {
  SEARCH_TAGS = 'searchTags',
  SEARCH_TYPE = 'searchType',
  SEARCH_STATUS = 'searchStatus',
  SEARCH_AI_TAGS = 'searchAiTags',
  SEARCH_NAME = 'searchName'
}

export interface SearchUrlParams {
  searchName?: string
  searchTags?: string[]
  searchType?: string
  searchStatus?: string[]
  searchAiTags?: string
}

export function removeParamFromURL(paramName: string) {
  const url = new URL(window.location.href)
  url.searchParams.delete(paramName)
  window.history.replaceState({}, '', url.toString())
}

export function removeParamsFromURL(paramNames: string[]) {
  const url = new URL(window.location.href)

  paramNames.forEach(paramName => {
    url.searchParams.delete(paramName)
  })

  window.history.replaceState({}, '', url.toString())
}

export function clearSearchParamsFromURL() {
  removeParamsFromURL(Object.values(SEARCH_PARAMS))
}

/**
 * Строит URL для страницы поиска с заданными параметрами
 */
export function buildSearchUrl(params: SearchUrlParams): string {
  const url = new URL(ROUTES.dashboard.allAssets, window.location.origin)

  // Сохраняем важные системные параметры из текущего URL
  const currentUrl = new URL(window.location.href)
  const inviteHash = currentUrl.searchParams.get(INVITE_HASH_PARAM_NAME)
  const signupHash = currentUrl.searchParams.get(SIGNUP_APPROVAL_HASH_PARAM_NAME)

  if (inviteHash) {
    url.searchParams.set(INVITE_HASH_PARAM_NAME, inviteHash)
  }

  if (signupHash) {
    url.searchParams.set(SIGNUP_APPROVAL_HASH_PARAM_NAME, signupHash)
  }

  if (params.searchName) {
    url.searchParams.set(SEARCH_PARAMS.SEARCH_NAME, JSON.stringify(params.searchName))
  }

  if (params.searchTags && params.searchTags.length > 0) {
    url.searchParams.set(SEARCH_PARAMS.SEARCH_TAGS, JSON.stringify(params.searchTags))
  }

  if (params.searchType) {
    url.searchParams.set(SEARCH_PARAMS.SEARCH_TYPE, JSON.stringify(params.searchType))
  }

  if (params.searchStatus && params.searchStatus.length > 0) {
    url.searchParams.set(SEARCH_PARAMS.SEARCH_STATUS, JSON.stringify(params.searchStatus))
  }

  if (params.searchAiTags) {
    url.searchParams.set(SEARCH_PARAMS.SEARCH_AI_TAGS, JSON.stringify(params.searchAiTags))
  }

  return url.pathname + url.search
}

/**
 * Строит URL для поиска по имени
 */
export function buildSearchByNameUrl(searchName: string): string {
  return buildSearchUrl({ searchName })
}

/**
 * Строит URL для поиска по тегам
 */
export function buildSearchByTagsUrl(tagIds: string[], searchType: string): string {
  return buildSearchUrl({ searchTags: tagIds, searchType })
}

/**
 * Строит URL для поиска по статусам
 */
export function buildSearchByStatusUrl(statusIds: string[], searchType: string): string {
  return buildSearchUrl({ searchStatus: statusIds, searchType })
}

/**
 * Строит URL для поиска по AI тегам
 */
export function buildSearchByAiTagsUrl(aiTag: string): string {
  return buildSearchUrl({ searchAiTags: aiTag })
}
